import React, { useEffect } from "react";
import "./Hiring_Partners.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useDispatch, useSelector } from "react-redux";
import { AllHiringPartners } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";


const Hiring_Partners = () => {

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const dispatch = useDispatch();

  const hiringPartners = useSelector(
    (state) => state.common.all_hiring_partners,
  );

  useEffect(() => {
    dispatch(AllHiringPartners());
  }, [dispatch]);

  // ✅ duplicate for seamless loop
  const partners = hiringPartners ? [...hiringPartners, ...hiringPartners] : [];

  if (!partners.length) return null;

   

  return (
    <section className="Hiring_Partners" ref={ref}>
      <div className="container">
        <div className="Hiring_Partners_title_holder">
          <h5 className="Hiring_Partners_title">
            <span className="title_number">
              {inView && <CountUp end={300} duration={2} enableScrollSpy scrollSpyOnce />}+
            </span>{" "}
            Hiring Partners
            <span className="bag_img">
              <img
                src="/assets/images/home/hiring_partners/bag.png"
                alt="bag-img"
                className="bag"
              />
            </span>
          </h5>
          <p className="title_text">
            Our learners work at leading product companies, startups, and MNCs.
          </p>
        </div>

        <div className="partner_swiper_holder">
          {/* Row 1 */}
          <div className="hiring_partner_swiper">
            <Swiper
              key={`row1-${partners.length}`}
              modules={[Autoplay]}
              slidesPerView="auto"
              spaceBetween={24}
              loop={true}
              speed={6000}
              allowTouchMove={false}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
              }}
              className="my_swiper_holder marquee_swiper"
            >
              {partners.map((src, index) => (
                <SwiperSlide key={index} style={{ width: "160px" }}>
                  <div className="partner_logo_card">
                    <img
                      src={`${IDS.IMG_URL}${src.image}`}
                      alt={`partner-${index}`}
                      className="brands_img"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Row 2 (reverse) */}
          <div className="hiring_partner_swiper">
            <Swiper
              key={`row2-${partners.length}`}
              modules={[Autoplay]}
              slidesPerView="auto"
              spaceBetween={24}
              loop={true}
              speed={6000}
              allowTouchMove={false}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                reverseDirection: true,
                pauseOnMouseEnter: false,
              }}
              className="my_swiper_holder marquee_swiper"
            >
              {partners.map((src, index) => (
                <SwiperSlide key={index} style={{ width: "160px" }}>
                  <div className="partner_logo_card">
                    <img
                      src={`${IDS.IMG_URL}${src.image}`}
                      alt={`partner-${index}`}
                      className="brands_img"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Row 3 */}
          <div className="hiring_partner_swiper">
            <Swiper
              key={`row3-${partners.length}`}
              modules={[Autoplay]}
              slidesPerView="auto"
              spaceBetween={24}
              loop={true}
              speed={6000}
              allowTouchMove={false}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
              }}
              className="my_swiper_holder marquee_swiper"
            >
              {partners.map((src, index) => (
                <SwiperSlide key={index} style={{ width: "160px" }}>
                  <div className="partner_logo_card">
                    <img
                      src={`${IDS.IMG_URL}${src.image}`}
                      alt={`partner-${index}`}
                      className="brands_img"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hiring_Partners;
